var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHalfstar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3837 2.21768C11.1825 1.12165 12.8175 1.12165 13.6163 2.21768L15.9853 5.46812C16.2328 5.8078 16.5811 6.06085 16.9807 6.19133L20.8041 7.43992C22.0933 7.86094 22.5985 9.41587 21.803 10.5143L19.4437 13.7717C19.1971 14.1122 19.0641 14.5216 19.0635 14.9419L19.0575 18.964C19.0555 20.3203 17.7328 21.2813 16.4423 20.8641L12.6152 19.6269C12.2153 19.4976 11.7847 19.4976 11.3848 19.6269L7.5577 20.8641C6.26722 21.2813 4.94451 20.3203 4.9425 18.964L4.93651 14.9419C4.93589 14.5216 4.80285 14.1122 4.5563 13.7717L2.197 10.5143C1.40146 9.41587 1.90669 7.86094 3.19592 7.43992L7.01932 6.19133C7.41888 6.06085 7.76718 5.8078 8.01474 5.46812L10.3837 2.21768Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4079 20.3844L13.3849 19.4074C12.5594 19.1406 12 18.3719 12 17.5043V2.54096C12 2.06246 12.6075 1.85729 12.8976 2.2378L15.8235 6.07524C16.0738 6.40353 16.4196 6.64632 16.8134 6.77029L20.378 7.8925C21.421 8.22086 21.8347 9.4754 21.1915 10.3597L18.8825 13.5346C18.6339 13.8764 18.5 14.2882 18.5 14.7109V18.8619C18.5 19.9479 17.4413 20.7184 16.4079 20.3844Z",
    fill: "#FFD646"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfstar);
export default __webpack_public_path__ + "static/media/halfstar.bba80319793dba33c517321cf114307f.svg";
export { ForwardRef as ReactComponent };